import { useStyletron } from '@thanx/uikit/theme'
import palette from 'constants/palette'
import { buildTranslate } from 'locales'
import React from 'react'
import type { LocationStatus } from '../mockLocations'
import { badgeBaseClass, locationStatusLabel } from './helpers'

const t = buildTranslate('locations.location_list')

export const StatusBadge = ({ enabled }: { enabled: boolean }) => {
  const [css] = useStyletron()
  return (
    <span
      className={`${badgeBaseClass(css)} ${css({
        backgroundColor: enabled ? palette.nephritis20 : palette.grey20,
        color: enabled ? palette.nephritis : palette.grey70,
      })}`}
    >
      {enabled ? t('badge.ordering_enabled') : t('badge.ordering_disabled')}
    </span>
  )
}

export const LocationStatusBadge = ({ status }: { status: LocationStatus }) => {
  const [css] = useStyletron()
  // Background/foreground pairs match the Figma palette tokens — green for
  // healthy, cayenne for errors, eggyolk for notices. Pulled into a tiny
  // map so adding a future kind only touches one place.
  const colors: Record<LocationStatus['kind'], { bg: string; fg: string }> = {
    healthy: { bg: palette.nephritis20, fg: palette.nephritis },
    errors: { bg: palette.cayenne10, fg: palette.cayenne },
    notices: { bg: palette.eggYolk10, fg: palette.eggYolk50 },
  }
  const { bg, fg } = colors[status.kind]
  return (
    <span
      className={`${badgeBaseClass(css)} ${css({
        backgroundColor: bg,
        color: fg,
      })}`}
    >
      {locationStatusLabel(status)}
    </span>
  )
}
